import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import Tooltip from 'comps/tooltip';
import { Col, Row, Text, Separator } from '@cuemath/comps';

const CustomRow = styled(Col)`
  & > * {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 767px) {
    display: block;
  }
`;

const Label = styled.label`
  width: 50%;
  height: 45px;
`;

const FeedbackGridRow = styled(Row)`
  flex-wrap: nowrap;
  padding: 2px;
`;

const ValueText = styled(Text)`
  line-height: 20px;
  color: #38383b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  width: ${({ width }) => (!width ? `9em` : width)};
`;

const InputCheckbox = styled.input`
  box-sizing: border-box;
  margin: 3px 3px 3px 4px;
  border: 1px solid rgba(42, 42, 46, 0.3);
  border-radius: 1px;
  background-color: #ffffff;
  cursor: pointer;
`;

const LabelStyle = styled(Text)`
  position: absolute;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: rgba(0, 0, 0, 0.3);
  padding: 15px;
`;

export default class CheckboxInput extends PureComponent {
  static defaultProps = {
    label: null,
    selected: [],
    onChange: () => {},
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string.isRequired),
    label: PropTypes.string,
    onChange: PropTypes.func,
  };

  onChange = e => {
    const { onChange } = this.props;

    onChange(e.target.value);
  };

  render() {
    const { name, label, options, selected, onChange, width } = this.props;

    const showLabel = label && label !== ' ';

    return (
      <Fragment>
        {showLabel && (
          <div>
            <LabelStyle>{label}</LabelStyle>
            <Separator height={40} transparent />
          </div>
        )}
        <CustomRow>
          {options.map(({ id, value }) => {
            const isChecked = selected.indexOf(value) > -1;

            return (
              <Label htmlFor={`${name}_${id}`} key={id}>
                <FeedbackGridRow key={`${name}_${id}`}>
                  <InputCheckbox
                    id={`${name}_${id}`}
                    name={id}
                    type="checkbox"
                    onChange={() => onChange(value)}
                    value={value}
                    checked={isChecked}
                  />
                  <Separator height={20} transparent />
                  {id.length > 20 ? (
                    <Tooltip title={id} position="bottom" width="100px">
                      <ValueText width={width}>{id}</ValueText>
                    </Tooltip>
                  ) : (
                    <ValueText width={width}>{id}</ValueText>
                  )}
                </FeedbackGridRow>
              </Label>
            );
          })}
        </CustomRow>
      </Fragment>
    );
  }
}
